import * as React from 'react';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n, isAuth } from 'arm-common';
import FondiAction from './fondi_action'
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { isNullOrUndefined } from 'util';
import BtnDelete from '../shared/BtnDelete.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { AppConstants } from '../../constants/AppConstants';
import CompagnieActions from '../compagnie/CompagnieActions'
import AppActions from '../../app/app_actions'
import ApplicationData from '../../app/aApplicationData';
import CompagniaTable from './../compagnie/compagniaTable.jsx';
import FondoCard from './fondoCard.jsx'

class FondiDetails extends React.Component {
    constructor(props) {
        super(props);
        this.editOnClick = this.editOnClick.bind(this);
        this.onClickBack = this.onClickBack.bind(this);
        this.modificaButton = this.modificaButton.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteFondo = this.deleteFondo.bind(this);
        this.indietroButton = this.indietroButton.bind(this);
        this.state = {
            showConfirm: false,
            validation: new Map(),
            showConfirmDelete: false,
            modificaCompagnia: false
        }
        this.showConfirmPanelCompagnia = this.showConfirmPanelCompagnia.bind(this);
        this.salvaCompagnia = this.salvaCompagnia.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.nuovoCompagnia = this.nuovoCompagnia.bind(this);
        this.deleteStrumentoCmp = this.deleteStrumentoCmp.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.salvaCompagniaStrumentoModifica = this.salvaCompagniaStrumentoModifica.bind(this);
        this.showConfirmPanelCompagniaModifica = this.showConfirmPanelCompagniaModifica.bind(this);
        this.validateFormCompagnia = this.validateFormCompagnia.bind(this);
        this.inputChangeHandlerCompagnie = this.inputChangeHandlerCompagnie.bind(this);
        this.downloadDocument = this.downloadDocument.bind(this);
        this.componentName = '[FondiDetails.jsx] ';
    }

    componentDidMount() {

        let fonId = "";
        if (!isNullOrUndefined(this.props.location.state.fonId)) {
            fonId = this.props.location.state.fonId;
        } else {
            fonId = this.props.fondoDetails.fonId;
        }

        console.log(fonId + "questo è il fonID")
        this.props.getFondoDetails(fonId);

        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'nomeCompagnia', title: i18n('ARM_CORE_PRODUCT.FONDI.COMPAGNIA', 'Compagnia') },
            { field: 'codStrumComp', title: i18n('ARM_CORE_PRODUCT.FONDI.COD_CMP', 'Codice compagnia') },
            { field: 'dateIns', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERT', 'Data inserimento'), formatter: this.dataFormat },
            { field: 'dataInizio', title: i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia'), formatter: this.dataFormat },
            { field: 'dataFine', title: i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia'), formatter: this.dataFormat },
            { field: 'dataInizioBanca', title: i18n('ARM_CORE_PRODUCT.SHARED.BANCA.DATA_INIZIO', 'Inizio Validità Banca '), formatter: this.dataFormat },
            { field: 'dataFineBanca', title: i18n('ARM_CORE_PRODUCT.SHARED.BANCA.DATA_FINE', 'Fine Validità Banca'), formatter: this.dataFormat },
            { field: 'dateAggiornamento', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA.AGGIORNAMENTO', 'Data Aggiornamento'), formatter: this.dataFormat },
            { field: 'edit', title: 'Modifica', formatter: this.columnEdit, },
            { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },
        ];


        $(this.refs.compagniaTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.fondoDetails.listStumentiCompagnia) {
            $(this.refs.compagniaTable).bootstrapTable('load', this.props.fondoDetails.listStumentiCompagnia);
        }

        this.props.getListCompagnie();

    }



    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.fondoDetails && nextProps.fondoDetails.listStumentiCompagnia) {
            if (nextProps.fondoDetails.listStumentiCompagnia !== this.props.fondoDetails.listStumentiCompagnia) {

                $(this.refs.compagniaTable).bootstrapTable('load', nextProps.fondoDetails.listStumentiCompagnia);
            }
        }
    }



    columnEdit(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-edit fa-fw'></i></button>";
        return temp;
    }

    editOnClick(row, $element, field) {
        console.log(this.componentName + " deleteOnClick()");

        if (field === "elimina") {
            this.inzializzaEliminaStrumCmp(row.id);
        } else if (field === "edit" && !this.props.disabled) {
            this.props.inizializzaModificaCompagnia(row).then(
                resolve => {
                    this.setState({
                        validation: new Map(),
                        modificaCompagnia: true
                    })
                    //this.showConfirmPanelFondo();
        }
            )

    }
    }

    inzializzaEliminaStrumCmp(codStrumComp) {

        this.setState({ strumCmpDaEliminare: codStrumComp, showConfirmDelete: true });

    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    deleteStrumentoCmp() {

        this.showConfirmDelete();

        this.props.deleteStrumentoCmp(this.state.strumCmpDaEliminare).then(

            resolve => {
                this.props.listaStrumentoCompagnie(this.props.fondoDetails.fonId).then(
                    resolve => {
                        // $(this.refs.compagniaTable).bootstrapTable('load', resolve);
                    }
                )
            }
        )
    }

    indietroButton() {
        console.log(this.componentName + 'indietroButton');
        if (!isNullOrUndefined(this.props.location.state) && this.props.location.state.goBackOfHistory) {
            this.props.history.goBack();
        } else {
            this.props.history.push({
                pathname: '/fondi/list',
            })
        }

    }

    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;
        if (this.state.validation.has(id)) {
            this.state.validation.delete(id);

        }
        this.props.handleChangeCompagniaStrum(id, value);

        this.validateForm();
    }

    inputChangeHandlerCompagnie(parametro, value) {

        let fondi = this.props.fondoDetails;
        let compagniaa = fondi.listStumentiCompagnia;
       
        if (parametro === "dataInizio" || parametro === "dataFine" || parametro === "dataInizioBanca" || parametro === "dataFineBanca") {
            let date = new Date(value);
            value = date.getTime();

        }
        this.props.inputChangeHandlerCompagnia(parametro, value).then(
            resolve => {
                if (parametro === "idCompagnia") {
                    if (compagniaa) {
                        let compagnieTrovato = this.props.compagniaa.find(cmp => cmp.id === Number(compagnia.idCompagnia));

                        if (compagnieTrovato) {
                            this.props.inputChangeHandlerCompagnia("denominazione", compagnieTrovato.denominazione).then(

                            )
                        }
                    }

                }

                this.validateFormCompagnia();
        }
        )

    }

    salvaCompagnia() {
        if (this.validateForm()) {
            this.showConfirmPanelCompagnia();
            this.props.salvaCompagnia().then(
                resolve => {
                    this.props.listaStrumentoCompagnie(this.props.fondoDetails.fonId).then(
                        resolve => {
                            // $(this.refs.compagniaTable).bootstrapTable('load', resolve);
                        }
                    )
                }
            )
        }
    }
    salvaCompagniaStrumentoModifica() {
        if (this.validateFormCompagnia()) {
            this.showConfirmPanelCompagniaModifica();
            this.props.salvaCompagniaStrumentoModifica().then(
                resolve => {
                    this.props.listaStrumentoCompagnie(this.props.fondoDetails.fonId).then(
                        resolve => {
                           
                        }
                    )

                }
            )
        }
    }

    dataFormat(value, row, index) {
        if (value === "0") {
            return "-";
        }

        return DateFormatter.dataFormatter(value);
    }
    onClickBack() {
        console.log(this.componentName + ' onClickBack')
        this.props.history.push({ pathname: '/fondi' })
    }

    modificaButton() {
        console.log(this.componentName + 'modificaButton');
        this.props.history.push({
            pathname: '/fondi/create', state: {
                id: this.props.fondoDetails.fonId,
                modifica: true
            }
        })

    }
    showConfirmPanel() {
        console.log(" show pop up");
        this.setState({ showConfirm: true })
    }

    showConfirmPanelCompagnia() {
        console.log(this.componentName + 'showConfirmPanel [showConfirm] ' + this.props.showConfirm);
        this.props.showPopUP(!this.props.showConfirm);
    }


    showConfirmPanelCompagniaModifica() {
        this.setState({ modificaCompagnia: !this.state.modificaCompagnia })
    }


    deleteFondo() {
        console.log(this.componentName + 'deleteFondo');
        let fonId = this.props.location.state.fonId;
        if (fonId === null) {
            return null
        }
        this.props.deleteFondo(fonId).then(
            resolve => {
                this.props.history.push({
                    pathname: '/fondi/list'
                });
                this.setState({ showConfirm: false })

            }, reject => {
                console.log(this.componentName + 'deleteFondo KO');
                this.setState({ showConfirm: false });
                $('html, body').animate({ scrollTop: 0 }, 1000);
                console.log(this.componentName + 'deleteFondo ' + this.props.state.dateDelete)
            }
        )


    }

    nuovoCompagnia() {
        console.log(this.componentName + "nuovoCompagnia: ");
        this.setState({
            validation: new Map(),
            modificaCompagnia: false
        })
        this.props.inizializzaNuovaCompagnia();
        this.showConfirmPanelCompagnia();



   }

    validateFormCompagnia() {

        console.log(this.componentName + 'validateFormCompagnia ');
        let validation = new Map();
        let required = ['idCompagnia', 'codStrumComp'];

        for (let i = 0; i < required.length; i++) {
            if (this.props.compagnia[required[i]] === undefined || this.props.compagnia[required[i]] === '' || this.props.compagnia[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        if (this.props.compagnia.idCompagnia && this.props.compagnia.idCompagnia !== "") {
            if (this.props.fondoDetails.listStumentiCompagnia && this.props.fondoDetails.listStumentiCompagnia.length > 0) {
                let comIndex = this.props.fondoDetails.listStumentiCompagnia.findIndex(cmp => cmp.idCompagnia === Number(this.props.compagnia.idCompagnia));
 
            }
            let compagnia = this.props.compagnia;

    
            if (compagnia.dataFine && compagnia.dataFine &&
                Number(compagnia.dataFine) < Number(compagnia.dataInizio)) {
                validation.set("dataFine", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', ' massima minore della  mininima'));
            }
            if (compagnia.dataFineBanca && compagnia.dataInizioBanca &&
                Number(compagnia.dataFineBanca) < Number(compagnia.dataInizioBanca)) {
                validation.set("dataFineBanca", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', ' massima minore della  mininima'));
            }


            this.setState({ validation: validation });
            if (validation.size === 0) {
                console.log(this.componentName + 'validateFormCompagnia -> false');
                return true;
            }
            console.log(this.componentName + 'validateFormCompagnia -> true');
            return false;

        }
    }


    validateForm() {
        console.log(this.componentName + 'validateForm ');
        let validation = new Map();
        let required = ['idCompagnia', 'codStrumComp'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.compagnia[required[i]] === undefined || this.props.compagnia[required[i]] === '' || this.props.compagnia[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        if (this.props.compagnia.idCompagnia && this.props.compagnia.idCompagnia !== "") {
            if (this.props.fondoDetails.listStumentiCompagnia && this.props.fondoDetails.listStumentiCompagnia.length > 0) {
                let comIndex = this.props.fondoDetails.listStumentiCompagnia.findIndex(cmp => cmp.idCompagnia === Number(this.props.compagnia.idCompagnia));

                if (comIndex !== -1) {
                    validation.set("idCompagnia", i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA_GIA_ASSOCIATA', 'compagnia già associata con lo strumento'));
                }
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            console.log(this.componentName + 'validateForm -> false');
            return true;
        }
        console.log(this.componentName + 'validateForm -> true');
        return false;
    }

    downloadDocument(documentId) {
        console.log(this.componentName + ' downloadDocument ');
        this.props.downloadDocument(documentId)
    }

    render() {
	       console.log(this.componentName + "render [indexCompagnia] " + this.props.index);
        if (isNullOrUndefined(this.props.compagnia)) {
            return;
        }
        let listProdottoLinea = this.props.listProdottoLinea;
        return (
            <div>
                <div className="card">
                    <div className="card-header">
                        <h3> {i18n('ARM_CORE_PRODUCT.FONDI.DETTAGLIO_FONDO', 'Dettaglio Fondo')} {this.props.fondoDetails.fonNome} - id {this.props.fondoDetails.fonId}</h3>
                    </div>

                    <div className="card-body">
                        <div>
                            <div className="mt-2 mb-2">
                                {this.props.fondoDetails ?
                                    <div>
                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.ID', 'id')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonId}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.DESRIZIONE', 'Descrizione')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonDescrizione}</dd>
                                            {/* <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.NOME', 'Nome')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonNome}</dd> */}
                                        </dl>
                                        {/* <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CATEGORIA', 'Categoria')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCategoria}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.DESRIZIONE', 'Descrizione')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonDescrizione}</dd>
                                        </dl> */}
                                        {/* <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.COMPAGNIA', 'Compagnia')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCompagnia}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.COMPAGNIA', 'Codice compagnia')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCodProdCompagnia}</dd>
                                        </dl> */}

                                        {/* <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.IMPORTO.MIN', 'Importo minimo')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonValMinImporto}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.IMPORTO.MAX', 'Importo massimo')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonValMaxImporto}</dd>
                                        </dl>
                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.PERCENTUALE.MIN', 'Percentuale minima')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonValMinPercentuale}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.PERCENTUALE.MAX', 'Percentuale massima')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonValMaxPecentuale}</dd>
                                        </dl>
                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.INIZIO.VALIDITA', 'Inizio validità')}</dt>
                                            <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.fondoDetails.fonInizioValidita)}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.FINE.VALIDITA', 'Fine validità')}</dt>
                                            <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.fondoDetails.fonFineValidita)}</dd>
                                        </dl>
                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.PRODOTTO', 'Codice prodotto')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCodProdotto}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.INTERNO', 'Codice interno')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCodIntero}</dd>
                                        </dl> */}
                                        <dl className="row">
                                            {/* <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.BANCA', 'Codice banca')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCodBanca}</dd> */}
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.TIPO', 'Tipo')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonTipo}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.ISIN', 'Codice isin')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonIsin}</dd>
                                        </dl>

                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.DIVISA', 'Divisa')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.fondoDetails.divisa ? ApplicationData.domainVal('COD_DIVPORT', this.props.fondoDetails.divisa).desDom : "-"}</dd>
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.DATE.MODIFICA', 'Data modifica')}</dt>
                                            <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.fondoDetails.dateUpd)}</dd>
                                        </dl>

                                        <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.FONDO.CODICE.BANCA', 'Codice Banca')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.fondoDetails.fonCodBanca}</dd>
                                        </dl>
                                    </div>
                                    :
                                    null
                                }

                            </div>
                        </div>
                        {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                            <agui.aButton className="float-left mt-2" bs='primary' onClick={this.nuovoCompagnia} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.FONDI.COMPAGNIA', 'Compagnia')}</agui.aButton>
                        }
                        <table ref="compagniaTable" className={AppConstants.CLASS_TABLE} />

                        <div className="row mt-3">
                        {
                            //dalla lista degli Linea presento a videso solo quello principale
                                <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                                    <FondoCard
                                    id = {this.props.fondoDetails.fonId} 
                                    disabled = {false}
                                    downloadDocument={this.downloadDocument}
                                    />
                                </div>
                            
                        }
                        <ConfirmModalDeleteV4
                            show={this.props.showPopUp}
                            testoTitle={i18n('ARM_CORE_PRODUCT.PRODOTTO.ELIMINA.LINEA', 'Confermi di voler Eliminare? ')}
                            deleteOnClick={this.onClickEliminaLinea}
                            onClose={this.showPopUP} />
                      </div>

                    </div>


                    <agui.aCardFooter>
                        <div className="float-left">
                            {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                                <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.modificaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                            }
                            {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                                <BtnDelete onClick={this.showConfirmPanel} className="" ></BtnDelete>
                            }
                        </div>
                        <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.indietroButton} >{i18n('ARM_CORE_PRODUCT.SHARED.INDIETRO', 'Indietro')}</agui.aButton>

                        <ConfirmModalDeleteV4
                            show={this.state.showConfirm}
                            deleteOnClick={this.deleteFondo}
                            onClose={() => this.setState({ showConfirm: false })} />
                    </agui.aCardFooter>

                </div>

                <agui.ConfirmModalOkCancelV4 show={this.props.showConfirm} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Compagnia" onClose={this.showConfirmPanelCompagnia} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idCompagnia"
                                    disabled={false}
                                    onChange={this.inputChangeHandler}
                                    value={this.props.compagnia ? this.props.compagnia.idCompagnia : null}
                                    label={i18n('ARM_CORE_PRODUCT.FONDI.ID_COMPAGNIA', 'Compagnia')}
                                    items={this.props.compagnie}
                                    validation={this.state.validation}
                                    valueKey="id"
                                    labelKey="denominazione"
                                />
                            </div>
                        </div>

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="codStrumComp" type="text"
                                    value={this.props.compagnia ? this.props.compagnia.codStrumComp : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.COD_CMP', 'Inserire codice compagnia')}
                                    required={true}
                                    validation={this.state.validation}
                                    label={i18n('ARM_CORE_PRODUCT.STRUM_CMP.COD_INTERNO', 'Codice Compagnia')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                        </div>


                        <div className="row mt-1">
                                <div className="col col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="dataInizio" type="date"
                                    value={this.props.compagnia.dataInizio ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataInizio) : ""}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                        required={true}
                                        validation={this.state.validation}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataInizio", e.target.value)} />
                                </div>

                                <div className="col col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="dataFine" type="date"
                                    value={this.props.compagnia.dataFine ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataFine) : ""}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                        required={true}
                                        validation={this.state.validation}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataFine", e.target.value)} />
                                </div>
                            </div>

                            <div className="row mt-1">
                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="dataInizioBanca" type="date"
                                    value={this.props.compagnia.dataInizioBanca ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataInizioBanca) : ""}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_BANCA', 'Inizio Validità Banca ')}
                                        required={true}
                                        validation={this.state.validation}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_DATA_BANCA', 'Inizio Validità Banca ')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataInizioBanca", e.target.value)} />
                                </div>
                                <div className="col col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="dataFineBanca" type="date"
                                    value={this.props.compagnia.dataFineBanca ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataFineBanca) : ""}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                        required={true}
                                        validation={this.state.validation}
                                        placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataFineBanca", e.target.value)} />
                                </div>
                            </div>

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaCompagnia} onClose={this.showConfirmPanelCompagnia}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>

                <agui.ConfirmModalOkCancelV4 show={this.state.modificaCompagnia} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Compagnia" onClose={this.showConfirmPanelCompagniaModifica} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idCompagnia" 
                                    disabled={false}
                                    required={true}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("idCompagnia", e.target.value)}
                                    value={this.props.compagnia ? this.props.compagnia.idCompagnia : null}
                                    label={i18n('ARM_CORE_PRODUCT.FONDI.ID_COMPAGNIA', 'Compagnia')}
                                    items={this.props.compagnie}
                                    validation={this.state.validation}
                                    valueKey="id"
                                    labelKey="denominazione"
                                />
                            </div>
                        </div>

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="codStrumComp" type="text"
                                    disabled={false}
                                    required={true}
                                    value={this.props.compagnia ? this.props.compagnia.codStrumComp : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.COD_CMP', 'Inserire codice compagnia')}
                                    validation={this.state.validation}
                                    label={i18n('ARM_CORE_PRODUCT.STRUM_CMP.COD_INTERNO', 'Codice Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("codStrumComp", e.target.value)} 
                                 />
                            </div>
                        </div>


                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataInizio" type="date"
                                    value={this.props.compagnia.dataInizio ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataInizio) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    required={true}
                                    validation={this.state.validation}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO', 'Inizio Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataInizio", e.target.value)} />
                            </div>


                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataFine" type="date"
                                    value={this.props.compagnia.dataFine ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataFine) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    required={true}
                                    validation={this.state.validation}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE', 'Fine Validità Compagnia')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataFine", e.target.value)} />
                            </div>
                        </div>

                        <div className="row mt-1">

                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataInizioBanca" type="date"
                                    value={this.props.compagnia.dataInizioBanca ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataInizioBanca) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_BANCA', 'Inizio Validità Banca ')}
                                    required={true}
                                    validation={this.state.validation}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_INIZIO_DATA_BANCA', 'Inizio Validità Banca ')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataInizioBanca", e.target.value)} />
                            </div>


                            <div className="col col-sm-12 col-md-6 col-lg-6">
                                <agui.ATextInputV4 id="dataFineBanca" type="date"
                                    value={this.props.compagnia.dataFineBanca ? DateFormatter.formatDateFromMilisToString(this.props.compagnia.dataFineBanca) : ""}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    required={true}
                                    validation={this.state.validation}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.FONDI.DATA_FINE_BANCA', 'Fine Validità Banca')}
                                    onChange={(e) => this.inputChangeHandlerCompagnie("dataFineBanca", e.target.value)} />
                            </div>
                        </div>

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaCompagniaStrumentoModifica} onClose={this.showConfirmPanelCompagniaModifica}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>

                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    testoBody={i18n('ARM_CORE_PRODUCT.COMPAGNIA.CONFERMI_ELIMINA_StrumCmp', 'Confermi l\'eliminazione dell compagnia con id: ') + this.state.strumCmpDaEliminare}
                    deleteOnClick={this.deleteStrumentoCmp}
                    onClose={this.showConfirmDelete} />

            </div>
        )
    }

}
function mapDispatchToProps(dispatch) {
    return {
        getFondoDetails(fonId) {
            return dispatch(FondiAction.getFondoDetails(fonId))
        },
        deleteFondo(fonId) {
            return dispatch(FondiAction.deleteFondo(fonId))
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        inizializzaNuovaCompagnia() {
            return dispatch(FondiAction.inizializzaNuovaCompagnia())
        },

        getListCompagnie() {
            return dispatch(CompagnieActions.getListCompagnie());
        },

        salvaCompagnia() {
            return dispatch(FondiAction.salvaCompagniaStrumento());
        },

        handleChangeCompagniaStrum(id, value) {
            return dispatch(FondiAction.handleChangeCompagniaStrum(id, value))
        },

        deleteStrumentoCmp(id) {
            return dispatch(FondiAction.deleteStrumentoCmp(id))
        },

        listaStrumentoCompagnie(codStrum) {
             return dispatch(FondiAction.listaStrumentoCompagnie(codStrum))
       },
       salvaCompagniaStrumentoModifica() {
            return dispatch(FondiAction.salvaCompagniaModifica());
        },
        inizializzaModificaCompagnia(row) {
            return dispatch(FondiAction.inizializzaModificaCompagnia(row));
        },
        inputChangeHandlerCompagnia(name, value) {
            return dispatch(FondiAction.inputChangeHandlerCompagnia(name, value))
        },
        downloadDocument(documentId) {
        return dispatch(AppActions.downloadDocument(documentId));
         },
   }
}


function mapStateToProps(state) {
    return {
        fondoDetails: state.fondi.detailsFondi,
        compagnia: state.fondi.compagnia,
        showConfirm: state.app.showPopUp,
        compagnie: state.compagnie.listaCompagnie,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FondiDetails);